var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnalisys(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1542_4223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.55469C6.5 2.55469 2 7.05469 2 12.5547C2 18.0547 6.5 22.5547 12 22.5547C17.5 22.5547 22 18.0547 22 12.5547C22 7.05469 17.5 2.55469 12 2.55469ZM12 20.5547C7.59 20.5547 4 16.9647 4 12.5547C4 8.14469 7.59 4.55469 12 4.55469C16.41 4.55469 20 8.14469 20 12.5547C20 16.9647 16.41 20.5547 12 20.5547ZM12.5 7.55469H11V13.5547L16.2 16.7547L17 15.4547L12.5 12.7547V7.55469Z",
    fill: "#F7941D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1542_4223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.851562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalisys);
export default __webpack_public_path__ + "static/media/analisys.f26a593ca435c7677c6131e3e147db2d.svg";
export { ForwardRef as ReactComponent };